import { Component } from '@angular/core';
import { IFaqs } from 'src/app/model/http/faqs.model';
import { StrappiService } from 'src/app/services/strappi.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  faqs: IFaqs = {};
  constructor(
    private strappiService: StrappiService
  ) {
    this.strappiService.getFaqs().subscribe(
      (res) => {
        this.faqs = res;
      },
    );
  }
}
